export default {
  getOrganization: (state) => state.organization,
};
